(function($) {

    users_containers_loader = '<div class="admin-containers-loader"><svg version="1.1" class="svg-loader" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve"><path opacity="0.2" fill="#000" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/> <path fill="#000" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z"><animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 20 20" to="360 20 20" dur="0.5s" repeatCount="indefinite"/> </path></svg></div>';
    users_profile_loader = '<div class="profile-containers-loader"><svg version="1.1" class="svg-loader" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve"><path opacity="0.2" fill="#000" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/> <path fill="#000" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z"><animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 20 20" to="360 20 20" dur="0.5s" repeatCount="indefinite"/> </path></svg></div>';
    users_file_upload_loader = '<div class="user-message-loader"><svg version="1.1" class="svg-loader" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve"><path opacity="0.2" fill="#000" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/> <path fill="#000" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z"><animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 20 20" to="360 20 20" dur="0.5s" repeatCount="indefinite"/> </path></svg></div>';
    _loader = '<div class="loader-container"><svg version="1.1" class="svg-loader" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve"><path opacity="0.2" fill="#000" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/> <path fill="#000" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z"><animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 20 20" to="360 20 20" dur="0.5s" repeatCount="indefinite"/> </path></svg></div>';
    wait = false;

    $(document).ready(function() {
        fix_tables_headers();
        show_section();
    })

    /*
    function getUrlParameter(sParam) {
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : sParameterName[1];
            }
        }
    }

    // get google ads click ID of this session
    function save_google_ad_click_id() {

        var key = 'gclid';
        var value = getUrlParameter('gclid');

        // if glid undefined exit function
        if (typeof value === 'undefined') {
            return;
        }

        // Save cookie
        document.cookie = key + '=' + value + '; path=/';

    }
    */

    function get_google_ad_click_id() {
        var gclid = getCookie('gclid');
        if (gclid === null) {
//            gclid = getUrlParameter('gclid');
//            if (typeof gclid === 'undefined') {
                gclid = '';
//            }
        }
        return gclid;
    }

    function getCookie(key) {
        var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
        return keyValue ? keyValue[2] : null;
    }

    function show_section() {
        $('.client-info-fader').fadeTo("fast", 1);
    }

    function fix_tables_headers() {

        if ($('.custom-table-header').size() < 1) {
            return;
        }

        $('.custom-table-header').each(function(index_1, el) {
            var custom_header = $(this);
            var table = $(el).parents('.table-holder').find('table');
            var columns = table.find('tr th');
            var columns_count = columns.size();

            var i = 0;

            $(columns).each(function(index_2, elelemnt) {
                var column_width = $(elelemnt).width() + 25;
                $(custom_header).find("span:eq( " + i + " )").css("width", column_width + 'px');
                i++;
            });

        });

        $('.custom-table-header').css('opacity', '1');

    }

    $(window).resize(function() {
        fix_tables_headers();
    });



    // REQUEST FORMS
    // ================================================================================================================================
    // ================================================================================================================================
    // ================================================================================================================================
    // ================================================================================================================================
    // ================================================================================================================================

    $('.user-account-tabs-wraper .tab-button').click(function() {

        $('.user-account-tabs-wraper .tab-button').removeClass('active');
        $(this).addClass('active');
        var container_name = $(this).data('tab-name')

        $('.client-info-fader').fadeTo("fast", 0);

        function show() {

            $('.user-info-container').removeClass('show');

            $('.user-info-container[data-user-info-container="' + container_name + '"]').addClass('show');

            $('.client-info-fader').fadeTo("fast", 1);

            if (container_name == 'profile') {
                $('.general-user-information').addClass('show');
            } else {
                $('.general-user-information').removeClass('show');
            }

            fix_tables_headers();

        }
        setTimeout(show, 200);

    });

    $('#close-maintanance-form').click(function() {
        $('.background-overlay').toggleClass('show');
        $('.maintanance-form').toggleClass('show');

    })


    function maintenance_enabled() {
        var result = false;
        if ($('html').hasClass('maintenance')) {
            result = true;
        }
        return result;
    }


    $('#close-maintanance-form').click(function() {
        $('.background-overlay').toggleClass('show');
        $('.maintanance-form').toggleClass('show');
    });

    $('.user-message-wrapper input').focus(function(e) {
        $(this).removeClass('error');
    });

    $(".submit-request-form").click(function() {


        if (maintenance_enabled()) {

            $('.background-overlay').toggleClass('show');
            $('.maintanance-form').toggleClass('show');
            display_maintanance_form();
            return;
        }


        var error = false;

        $('.form-message-bad').text('');
        $('.form-message-container').css('display', 'none');

        if ($('.user-message-wrapper .allow-send').val()) {
            error = true;
        }

        var user_email = sanitize($('.user-message-wrapper input[name="user_email"]').val());
        var user_name = sanitize($('.user-message-wrapper input[name="user_full_name"]').val());
        var user_phone = sanitize($('.user-message-wrapper input[name="user_phone"]').val());
        var user_company = sanitize($('.user-message-wrapper input[name="user_company_name"]').val());
        var country_with_number = sanitize($('.intl-tel-input .selected-flag').attr("title"));
        // console.log(country_with_number);
        if (country_with_number == undefined) {
            var user_country = '';
        } else {
            var country_number_array = country_with_number.split(':');
            var user_country = country_number_array[0];
        }
        console.log(user_country);


        if (user_phone == undefined || user_phone.length < 6) {
            user_phone = '';
        }

        // IF EMAIL IS INCORRECT
        if (!isValidEmailAddress(user_email) && user_email != undefined) {
            $('.user-message-wrapper input[name="user_email"]').addClass('error');
            message = "The email you have entered is invalid. Pleach check again.";
            $('.form-message-bad').text(message);
            $('.form-message-container').css('display', 'block');
            error = true;
        }

        // IF Company name IS INCORRECT
        if (user_company != undefined && user_company != '') {
            if (!isValidCompanyName(user_company) && user_company != undefined) {
                $('.user-message-wrapper input[name="user_company_name"]').addClass('error');
                message = "The company name you have entered is invalid. Pleach check again.";
                $('.form-message-bad').text(message);
                $('.form-message-container').css('display', 'block');
                error = true;
            }
        }

        $('.user-message-wrapper .required').each(function(index) {
            if (!$(this).val()) {
                $(this).addClass('error');
                message = "You must fill all required fields.";
                $('.form-message-bad').text(message);
                $('.form-message-container').css('display', 'block');
                error = true;
            }
        });

        if (full_name_check(user_name) == false) {
            $('.user-message-wrapper input[name="user_full_name"]').addClass('error');

            message = "Please enter your full name.";
            $('.form-message-bad').text(message);
            $('.form-message-container').css('display', 'block');
            error = true;
        }




        if (error) {
            return;
        }
        var weekly = '';
        var request_type = $("#request-form").data('service-type');
        if (request_type == "database-subscription-weekly") {
            request_type = "database-subscription";
            weekly = 'Weekly ';
        }
        var database_type = $("#request-form").data('database-type');
        var subscription_plan = '';

        var criteria = {};

        console.log(request_type);
        if (request_type == "database-subscription") {
            criteria['Access'] = $('input[name="subscription-plan"]:checked').val();
            subscription_plan = $('input[name="subscription-plan"]:checked').data('subscription-plan');
            if (subscription_plan == 'weekly') {
                weekly = 'Weekly ';
            } else if (subscription_plan == 'yearly') {
                weekly = 'Yearly ';

            }
        }

        var write_up = false;
        if ($('#write-up').is(':checked')) {
            criteria['Write-up'] = 'I would like to order RoyaltyRange search strategy write-up';
            write_up = 'true';
        }

        if (request_type == "one-search" || request_type == "benchmarking-study") {
            $('.added-criteria-input').each(function(index, el) {
                var key = $(this).data('criteria');
                var criterion = $(this).val();
                criteria[key] = criterion;
            });
        }

        var user_message = $("#user-message").val();
        var user_id = $('#request-form').data('user-id');


        if (!user_email) {
            user_email = $('#request-form').data('user-email');
        }

        $('.submit-request-form').css('display', 'none');
        $('.request-form-loader-container').css('display', 'block');

        var currency = $('#request-form').data('user-currency');

        var gclid = get_google_ad_click_id();
        $.ajax({
            type: 'POST',
            url: ajax_object.ajaxurl,
            dataType: 'text',
            data: {
                action: "user_send_request",
                user_message: user_message,
                user_id: user_id,
                user_email: user_email,
                user_name: user_name,
                user_company: user_company,
                user_country: user_country,
                request_type: request_type,
                subscription_plan: subscription_plan,
                currency: currency,
                database_type: database_type,
                weekly: weekly,
                write_up: write_up,
                user_phone: user_phone,
                front_page: '',
                mobile: '',
                gclid: gclid,
                criteria: JSON.stringify(criteria)
            },
            success: function(response) {

                adwords_one_search_benchmarking_subscription(request_type, database_type, subscription_plan, currency, write_up);
                bing_lead_conversion();
                window.location.href = "/thank-you-reg/";

            },
            error: function(response) {
                console.log(response);
            }
        });
    });


    // ADWORDS FUNCTIONS
    function adwords_one_search_benchmarking_subscription(request_type, database_type, subscription_plan, currency, write_up) {
    /*
        var event_name, name, id, category, variant, database;

        if (request_type == "one-search") {
            event_name = "OneSearchLead";
            category = "One Search";
        }
        if (request_type == "benchmarking-study") {
            event_name = "BenchmarkingLead";
            category = "Benchmarking Study";
        }
        if (request_type == "database-subscription") {
            event_name = "SubscriptionLead";
            category = "Subscription";
        }

        if (request_type == "lead-search") {
            event_name = "RequestLeadSearch";
        }

        if (request_type == "company-financials-search") {
            event_name = "CompanyFinancialsSearch";
        }

        if (database_type == "royalty-rates") database = "Royalty Rates";
        if (database_type == "loan-interest-rates") database = "Loan Interest Rates";
        if (database_type == "service-fees") database = "Service Fees";
        if (database_type == "company-financials") database = "Company Financials";

        name = category + " " + database;

        if (name == "One Search Royalty Rates") id = 11111;
        if (name == "One Search Loan Interest Rates") id = 11112;
        if (name == "One Search Service Fees") id = 11113;
        if (name == "Benchmarking Study Royalty Rates") id = 11114;
        if (name == "Benchmarking Study Loan Interest Rates") id = 11115;
        if (name == "Benchmarking Study Service Fees") id = 11116;
        if (name == "Subscription Royalty Rates") id = 11117;
        if (name == "Subscription Loan Interest Rates") id = 11118;
        if (name == "Subscription Service Fees") id = 11119;
        if (name == "One Search Company Financials") id = 11120;
        if (name == "Subscription Company Financials") id = 11121;
        if (name == "Request Lead Search ") id = 11122;
        variant = "";
        if (write_up) {
            variant = "Write-up";
        }

        // console.log("currency: " + currency);
        // console.log("name: " + name);
        // console.log("id: " + id);
        // console.log("category: " + category);
        // console.log("database: " + database);
        // console.log("subscription_plan: " + subscription_plan);
        // console.log("variant: " + variant);
        var today = new Date().toJSON();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'formSubmitSuccess',
            timeStamp: today,
            form_name: event_name,
            form_id: id,
            ecommerce: {
                currencyCode: currency,
                purchase: [{
                    products: [{
                        name: name, // Product name
                        id: id, // product ID
                        // price: '500',  // product price
                        category: category, // Product category
                        database: database,
                        plan: subscription_plan,
                        variant: variant // write-up option
                    }]
                }]
            }
        });
    */
    }


    function bing_lead_conversion() {
        // (function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:"5662786"};o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,"script","//bat.bing.com/bat.js","uetq");

        // (function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:"5662786"};o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,"script","//bat.bing.com/bat.js","uetq");
        //
        // window.uetq = window.uetq || [];
        //
        // window.uetq.push('event', 'Lead', {'event_category': 'Lead', 'event_label': 'Lead', 'event_value': 400});

    }





    function closePopupWindow() {
        console.log('uzdarom');
        var parentForm = $(this).data('form-type');
        var currentPopupForm = $(this).parent();
        var allTopics = '';
        $(currentPopupForm).find('.selected-topic-wrapper').each(function() {
            var currentTopic = $(this).attr('topic');
            allTopics += currentTopic + ', ';
        });

        if ($(currentPopupForm).find('.custom-enter-field input').val()) {
            allTopics += $(currentPopupForm).find('.custom-enter-field input').val() + ', ';
        }
        // remove comma
        allTopics = allTopics.substring(0, allTopics.length - 2);

        $('.background-overlay').removeClass('show');


        var input = '';
        if (parentForm == "nace") {
            input = $('.criteria-input-container[name="NACE rev. 2"] textarea');
            $(".criteria-selections").focus();
        } else if (parentForm == "sic") {
            input = $('.criteria-input-container[name="SIC"] textarea');
            $(".criteria-selections").focus();
        } else if (parentForm == "country") {
            input = $('.criteria-input-container[name="Territory"] textarea');
            $(".criteria-selections").focus();
        } else if (parentForm == "profitlevel") {
            input = $('.criteria-input-container[name="ProfitLevel"] textarea');
            $(".criteria-selections").focus();
        }

        input.val(allTopics);

        setTimeout(function() {
            input.css('height', 'auto');
            input.css('padding', '9px 16px');
            input.css('height', (input.get(0).scrollHeight + 2) + 'px');
        }, 3);

        $('.popup-form').removeClass('show');
    }


    $('#front-page-one-search-request-form.overview-form').on('click', '.close-popup', closeFrontPageRequestForm);

    function closeFrontPageRequestForm() {
        $('#submit-front-page-request-form').data('step', '1');
        $('.first-step').css('display', 'block');
        $('.second-step').css('display', 'none');
        $('.third-step').css('display', 'none');
        $('#front-page-one-search-request-form .close-popup').css('display', 'none');
        $('#front-page-one-search-request-form .one-search-form-container').css('background-color', 'rgba(255,255,255,0,2)');
        $('#front-page-one-search-request-form.overview-form').removeClass('second-step-active');
        $('.front-page-background-overlay').removeClass('show');
        $(".front-page-header .width-wrap").css("z-index", "2");

        var new_keywords = $('#front-page-one-search-request-form .second-step .added-criteria-input[data-criteria="Key Words"]').val();
        $('#front-page-one-search-request-form .first-step .added-criteria-input[data-criteria="Key Words"]').val(new_keywords);
    }

    $('.front-page-background-overlay').click(function() {
        closeFrontPageRequestForm();
    });


    $('body').keyup(function(e) {
        if (e.keyCode == 27) { // escape key maps to keycode `27`
            closeFrontPageRequestForm();
        }
    });

    // SELECT SERVICE CLICK
    $('.new-request-form .service-selection-options .button').click(function() {


        $('.new-request-form .form-buttons-wrapper .button').removeClass('selected');
        $(this).addClass('selected');
        var service_type = $(this).data('service-type');

        $('#request-form').trigger("reset");
        $('.SumoSelect .opt').removeClass('selected');
        $('.SumoSelect .topics').empty();


        $('.criteria-input-container').remove();

        $('.form-selections-wrapper').fadeTo("fast", 0).delay(100).fadeTo("fast", 1);

        $('.request-form-pricing').css('display', 'none');
        $('.request-form-pricing.royalty-rates').css('display', 'inline-block');

        function show() {

            $('.exclusivity-container').css('display', 'block');

            $('.service-form').removeClass('show');

            if (service_type == 'transfer-pricing-documentation' || service_type == 'research-and-data-collection' || service_type == 'training') {
                $('.service-form[data-service-form="Universal form"]').addClass('show');
            }

            $('.service-form[data-service-form="' + service_type + '"]').addClass('show');

            $("#request-form").data('service-type', service_type);
            $('.database-select-wrapper .button').removeClass('selected');
            $('.database-select-wrapper .button[data-database-type="royalty-rates"]').addClass('selected');
            $("#request-form").data('database-type', 'royalty-rates');



        }
        setTimeout(show, 170);


    });

    // DOCUMENTS TYPE SELECT CLICK

    $('.user-info-container[data-user-info-container="documents"] .service-selection-options .button').click(function() {

        var files_type = $(this).data('service-type');

        $('.form-selections-wrapper').fadeTo("fast", 0).delay(100).fadeTo("fast", 1);

        $('.user-info-container[data-user-info-container="documents"] .service-selection-options .button').removeClass('selected');
        $(this).addClass('selected');

        function show() {
            $('.files-container-wrapper').css('display', 'none');
            $('.files-container-wrapper[data-file-container-type="' + files_type + '"]').css('display', 'block');
            fix_tables_headers();
        }
        setTimeout(show, 170);



    });


    // database select button clicked
    $('.database-select-wrapper .button').click(function() {

        $('#request-form').trigger("reset");
        $('.SumoSelect .opt').removeClass('selected');
        $('.criteria-input-container').remove();
        $('.topics').empty();

        $('.database-select-wrapper .button').removeClass('selected');
        $(this).addClass('selected');
        var database_type = $(this).data('database-type');
        $('.plans-container').removeClass('show');
        $('.plans-container[data-plans-container="' + database_type + '"]').addClass('show');

        $('.plans-container[data-plans-container="' + database_type + '"] input:first').prop('checked', true);

        $("#request-form").data('database-type', database_type);

        if (database_type == 'loan-interest-rates') {
            $('.exclusivity-container').css('display', 'none');
        } else {
            $('.exclusivity-container').css('display', 'block');
        }

        if ($('.new-table-holder.hideable').length > 0) {
            display_hidable_price_tables(database_type);
        }

        // CHANGE ONE SEARCH PRICE IN THE DESCRIPTION
        $('.request-form-pricing').css('display', 'none');
        $('.request-form-pricing.' + database_type).css('display', 'inline-block');

    })

    function display_hidable_price_tables(database_type) {
        $('.hideable').removeClass('show');

        $('.hideable[data-table-database-type="' + database_type + '"]').addClass('show');
    }


    $('.criteria-selections .criteria-option').change(function(event) {
        var name = $(this).attr('name')
        if ($(this).prop('checked')) {
            var input = '<div class="criteria-input-container" name="' + name + '"><label>' + name + ':</label><textarea class="added-criteria-input autogrow" data-criteria="' + name + '" rows="1"></textarea></div>';
            $(this).parents('.service-form').find('.added-criteria-inputs-wrapper').append(input);
        } else {
            $('.criteria-input-container[name="' + name + '"]').remove();
        }

    });


    $('.criteria-selections .plus-icon').click(function(e) {
        e.preventDefault();

        // $.ajax({
        //     url: ajax_object.ajaxurl,
        //     type: "get",
        //     data: {
        //         'action': 'form_popup_ajax_request', // This is our PHP function below
        //     },
        //     success: function(result) {
        //         // This outputs the result of the ajax request (The Callback)
        //         // var results = data.data;

        //         // $('#front-page-one-search-nic-sic-forms').empty();
        //         // $('#front-page-one-search-nic-sic-forms').appendChild(result.data);
        //         // var form_container = document.getElementById('front-page-one-search-nic-sic-forms');
        //         // empty(form_container);
        //         // form_container.html(result.data);
        //         homepage_one_search_form_activate_load_assets();
        //         // window.alert(result.data);
        //     },
        //     error: function(errorThrown) {
        //         console.log(errorThrown);
        //         // window.alert(errorThrown);
        //     }
        // });

        $('.background-overlay').addClass('show');

        var name = $(this).data("form-type");

        // Check the criteria
        $('.criteria-option[name="' + name + '"]').prop('checked', true);

        var service_type = $('.overview-form').data('service-type');
        if (!service_type) {
            service_type = $(this).parents(".service-form").data('service-form');
        }
        var added_criteria_wrapper = $('.added-criteria-inputs-wrapper');

        if (service_type == 'one-search') {
            added_criteria_wrapper = $('.one-search-criteria-wrapper .added-criteria-inputs-wrapper');
        } else if (service_type == 'benchmarking-study') {
            added_criteria_wrapper = $('.benchmarking-study-criteria-wrapper .added-criteria-inputs-wrapper');
        }

        // Add input if doesn't exists
        if (added_criteria_wrapper.find('.criteria-input-container[name="' + name + '"]').length < 1) {
            var input = '<div class="criteria-input-container" name="' + name + '"><label>' + name + ':</label><textarea class="added-criteria-input autogrow" data-criteria="' + name + '" rows="1" style="max-height:68px;"></textarea></div>';
            added_criteria_wrapper.append(input);
        }


        if (name == 'NACE rev. 2') {
            $('#Nace-2-form').addClass('show');
            setTimeout(function() { $("#Nace-2-form .close-form").focus(); }, 20);

        } else if (name == 'SIC') {
            $('#SIC-form').addClass('show');
            setTimeout(function() { $("#SIC-form .close-form").focus(); }, 20);
        } else if (name == 'Territory') {
            $('#country-form').addClass('show');
            setTimeout(function() { $("#country-form .close-form").focus(); }, 20);
        } else if (name == 'ProfitLevel') {
            $('#profitlevel-form').addClass('show');
            setTimeout(function() { $("#profitlevel-form .close-form").focus(); }, 20);
        }

    });


    // USER FILES
    // ================================================================================================================================
    // ================================================================================================================================
    // ================================================================================================================================
    // ================================================================================================================================
    // ================================================================================================================================



    $(document).ready(function() {

        var user_ID = $('.client-info-wrapper').data('user-id');

        //IF USER DOCUMENTS TAB
        if ($('#admin-uploaded-files').length) {
            // PREPARE ADMIN FILES CONTAINER
            var files_container = $('#admin-uploaded-files');
            files_container.css('padding-bottom', '64px');
            var parent = $('#downloads');
            get_files('admin-uploads', 1, files_container, parent);

            // PREPARE USER FILES CONTAINER
            var files_container = $('#user-uploaded-files');
            files_container.css('padding-bottom', '64px');
            var parent = $('#uploads');
            get_files('user-uploads', 1, files_container, parent);

            // PREPARE USER BILLS AND CONTRACTS CONTAINER
            var files_container = $('#user-contract-files');
            files_container.css('padding-bottom', '64px');
            var parent = $('#contracts');
            get_files('user-contracts', 1, files_container, parent);

            // PREPARE USER INVOICES CONTAINER
            var files_container = $('#invoice-files');
            files_container.empty();
            files_container.css('padding-bottom', '64px');
            var parent = $('#invoices');
            get_invoices('not paid', 1, files_container, parent);

        }

        if ($('.database-select-wrapper .button').hasClass('selected')) {
            database_type = $('.database-select-wrapper .button.selected').data('database-type');
            $('.request-form-pricing').css('display', 'none');
            $('.request-form-pricing.' + database_type).css('display', 'inline-block');
        }


    });

    $('.ajax-append-files').on('scroll', function() {
        var files_container = $(this).data('container-id');
        var files_container = $('#' + files_container);
        var parent = $(this);
        var page = $(this).data('page-number');
        var file_type = $(this).data('file-type');

        if (page === 'lastpage') {
            return;
        }
        if (($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) && wait === false) {
            var user_ID = $('.client-info-wrapper').data('user-id');
            page = parseInt(page) + 1;
            $(this).data('page-number', page);
            get_files(file_type, page, files_container, parent);
        }
    });

    function get_files(file_type, page, files_container, parent) {
        wait = true;
        $.ajax({
            url: ajax_object.ajaxurl,
            type: "post",
            data: {
                action: "get_files",
                file_type: file_type,
                page: page,
            },
            cache: false,
            success: function(result) {
                var element_count = result.length;
                if (element_count < 10) {
                    parent.data('page-number', 'lastpage');
                    parent.css('padding-bottom', '0');
                } else {
                    parent.data('page-number', page);
                }

                switch (file_type) {
                    case 'admin-uploads':
                        display_admin_files(result, files_container);
                        break;
                    case 'user-uploads':
                        display_user_files(result, files_container);
                        break;
                    case 'user-bills':
                        display_user_bills(result, files_container);
                        break;
                    case 'user-contracts':
                        display_user_contracts(result, files_container);
                        break;
                    default:
                        break;
                }

                wait = false;
            },
            dataType: "json",
        });
    }

    function formatDate(date) {
        date = new Date(date);
        var mm = date.getMonth() + 1;
        var dd = date.getDate();
        var yyyy = date.getFullYear();
        if (mm < 10) {
            mm = '0' + mm;
        }
        if (dd < 10) {
            dd = '0' + dd;
        }
        return yyyy + "-" + mm + "-" + dd;
    }

    function display_admin_files(files, files_container) {
        var html = '';

        $.each(files, function(j, file) {
            var urls = file.file_url.split(',');
            var date = formatDate(file.uploadDateTime);
            var download_links = '<td class="cell download-links">';
            var i = 0;
            $.each(urls, function(i, url) {
                var extension = url.split('.').pop();
                download_links += '<a class="file-download-link" href="/download-file/?a=1&b=' + file.ID + '&c=' + i + '&download=direct" target="_blank" title="' + file.file_name + '" ><div class="file-download-box type-' + extension + '"></div></a>';
                i++;
            });
            download_links += '</td>';
            var file_type = capitalizeFirstLetter(file.is_primary);
            html += '<tr class="file"><td class="cell date">' + date + '</td><td class="cell name">' + file.file_name + '</td><td>' + file_type + '</td>' + download_links + '</tr>';
        });
        files_container.append(html);
    }

    function display_user_files(files, files_container) {
        var html = '';
        $.each(files, function(j, file) {
            var urls = file.file_url.split(',');
            var date = formatDate(file.uploadDateTime);
            var download_links = '<td class="cell download-links">';
            $.each(urls, function(i, url) {
                var extension = url.split('.').pop();
                download_links += '<a class="file-download-link" href="/download-file/?a=2&b=' + file.ID + '&download=direct" target="_blank" title="' + file.file_name + '" ><div class="file-download-box type-' + extension + '"></div></a>';
            });
            download_links += '</td>';
            html += '<tr class="file "><td class="date">' + date + '</td><td class="name" >' + file.file_name + '</td>' + download_links + '</tr>';

        });
        files_container.append(html);
    }

    function display_user_contracts(files, files_container) {
        var html = '';
        $.each(files, function(j, file) {
            urls = file.file_url.split(',');
            var date = formatDate(file.uploadDateTime);
            var download_links = '<td>';
            $.each(urls, function(i, url) {
                var extension = url.split('.').pop();
                download_links += '<a class="file-download-link" href="/download-file/?a=4&b=' + file.ID + '&download=direct" target="_blank" title="' + file.file_name + '" ><div class="file-download-box type-' + extension + '"></div></a>';
            });
            download_links += '</td>';

            html += '<tr class="file"><td class="date">' + date + '</td><td class="name">' + file.file_name + '</td>' + download_links + '</tr>';
        });
        files_container.append(html);
    }

    $('.ajax-append-invoices').on('scroll', function() {
        var files_container = $(this).data('container-id');
        var files_container = $('#' + files_container);
        var parent = $(this);
        var page = $(this).data('page-number');
        var file_type = $(this).data('file-type');

        if (page === 'lastpage') {
            return;
        }
        if (($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) && wait === false) {
            var user_ID = $('.client-info-wrapper').data('user-id');
            page = parseInt(page) + 1;
            $(this).data('page-number', page);
            get_invoices('paid', page, files_container, parent);
        }
    });

    function get_invoices(status, page, files_container, parent) {
        wait = true;

        $.ajax({
            url: ajax_object.ajaxurl,
            type: "post",
            data: {
                action: "get_invoices",
                status: status,
                page: page,
            },
            cache: false,
            success: function(result) {
                var element_count = result.length;
                if (element_count < 10) {
                    parent.data('page-number', 'lastpage');
                    parent.css('padding-bottom', '0');
                } else {
                    parent.data('page-number', page);
                }

                display_invoices(result, status, files_container, page);

                if (status == 'not paid' && page == 1) {
                    get_invoices('in progress', 1, files_container, parent);
                }

                if (status == 'in progress' && page == 1) {
                    get_invoices('paid', 1, files_container, parent);
                }

                fix_tables_headers();

                wait = false;
            },
            dataType: "json",
        });
    }

    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    function display_invoices(files, status, files_container, page) {
        var html = '';
        if (files.length == 0) {
            return;
        }

        if (status == 'not paid' && page == 1) {
            html = '<tr class="file file-type-row"><td><h3>Unpaid invoices</h3></td><td></td><td></td><td></td><td></td></tr>';
        } else if (status == 'in progress' && page == 1) {
            html = '<tr class="file file-type-row" ><td><h3>In progress</h3></td><td></td><td></td><td></td><td></td></tr>';
        } else if (status == 'paid' && page == 1) {
            html = '<tr class="file file-type-row" ><td><h3>Paid invoices</h3></td><td></td><td></td><td></td><td></td></tr>';
        }

        var currency = 'eur';


        $.each(files, function(j, file) {
            var urls = file.file_url.split(',');
            var download_links = '<td class="cell download-links">';
            var date = formatDate(file.uploadDateTime);
            $.each(urls, function(i, url) {
                var extension = url.split('.').pop();
                download_links += '<a class="file-download-link" href="/download-file/?a=3&b=' + file.ID + '&download=direct" target="_blank" title="' + file.file_name + '" ><div class="file-download-box type-' + extension + '" style="margin-top: 7px;margin-right: 10px;"></div></a>';
            });


            amount = file.amount / 100;

            var currency = file.currency;
            var symbol = '€';
            if (currency == '') {
                currency = 'EUR';
            }

            if (currency == 'USD') {
                symbol = '$';
            }

            if (status == 'not paid' || status == 'Not paid' || status == 'Unpaid') {

                // var user_id = $("html").data('user-id');
                // if (user_id == "1000"){
                download_links += '<form class="" action="/home/payment" method="post"><input type="hidden" name="payment_type" value="invoice"><input type="hidden" name="currency" value="' + currency + '"><input type="hidden" name="invoice_id" value="' + file.ID + '">  <input type="submit" class="button empty" value="PAY NOW"></form></td>';
                // }else{
                //     download_links += '<div class="bfilepay" data-payment-id="'+file.ID+'" data-payment-amount="'+file.amount+'" data-payment-currency="'+currency+'" data-payment-name="'+file.file_name+'" data-stripe-account="'+file.stripe_account+'" >Pay now</div></td>';
                // }



            } else {
                download_links += '</td>';
            }

            status = capitalizeFirstLetter(status);
            if (status == "Not paid") {
                status = "Unpaid";
            }

            html += '<tr class="file "><td class="cell date">' + date + '</td><td class="cell name">' + file.file_name + '</td><td class="invoice-amount" >' + symbol + '' + amount + '</td><td>' + status + '</td>' + download_links + '</tr>';

        });

        files_container.append(html);
    }

    // USER UPLOAD FILE
    // ===================================================================================================================

    $('body').on('click', '.upload-user-file.disabled', function(e) {
        e.preventDefault();
    });

    $('body').on('change', '#user-upload-file', function(e) {
        if ($(this).parents('.upload-user-file').hasClass('disabled')) {
            return;
        }

        var file = this.files[0];
        var files = this.files;
        var file_name = file.name;
        var type = file_name.split('.').pop().toLowerCase();

        $("#upload-files-info-container").empty();

        if (file.size > 5000000) { // file max size 5mb 5000000
            $('#upload-files-info-container').append('<h3>The file is too big (Max 5Mb)</h3>');
            this.value = null;
            return;
        }

        var fd = new FormData();
        var user_ID = $('.client-info-wrapper').data('user-id');
        var user_email = $('.client-info-wrapper').data('user-email');

        $.each(files, function(j, file) {
            fd.append('files[' + j + ']', file);
        });

        fd.append('action', 'user_upload_files');
        fd.append('user_ID', user_ID);
        fd.append('user_email', user_email);
        fd.append('file_name', file_name);

        $('.upload-user-file').addClass('disabled');
        $("#upload-files-info-container").append('<div class="upload-files-loader-container"><h3>Please wait while your file is being uploaded. </h3><svg version="1.1" class="svg-loader" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="30px" height="30px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve"><path opacity="0.2" fill="#000" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/> <path fill="#000" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z"><animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 20 20" to="360 20 20" dur="0.5s" repeatCount="indefinite"/> </path></svg></div>');
        this.value = null;

        $.ajax({
            type: 'POST',
            url: ajax_object.ajaxurl,
            data: fd,
            contentType: false,
            processData: false,
            success: function(response) {
                var user_ID = $('.client-info-wrapper').data('user-id');
                var files_container = $('#user-uploaded-files');
                files_container.empty();
                var parent = $('#uploads');
                get_files("user-uploads", 1, files_container, parent);
                $("#upload-files-info-container").empty();
                $("#upload-files-info-container").append('<h3>Your file has been uploaded successfully!</h3>');
                $('.upload-user-file').removeClass('disabled');

            }
        });

    });


    // REMOVE OPTION
    $('#requestform').on('click', '.remove-option', function() {
        var topic = $(this).attr('criteria');
        $('#requestform').find('input[type=checkbox][value="' + topic + '"]').prop("checked", false);
        $(this).closest('.added-input').remove();
    });

    $('body').on('focus', '#visitor-email', function() {
        $(this).removeClass('error-input');
    });

    $('body').on('focus', '#visitor-name', function() {
        $(this).removeClass('error-input');
    });


    // SUBMIT REQUEST
    $('body').on('click', 'input[name="subscription_plan"]', function() {
        var amount = $(this).data('amount');
        $("#user-request-form").data("amount", amount);

        var subscription_plan = $(this).data('subscription-plan');
        $("#user-request-form").data("subscription-plan", subscription_plan);

        var crm_request_type = $(this).data('crm-request-type');
        $("#user-request-form").data("crm-request-type", crm_request_type);

        var crm_subscription_plan = $(this).data('crm-subscription-plan');
        $("#user-request-form").data("crm-subscription-plan", crm_subscription_plan);
    });


    function display_request_content(request_content) {
        var message = request_content.message;
        var request_type = request_content.request_type;
        var criteria = request_content.criteria;

        $.each(criteria, function(key, value) {});
    }

    function isValidEmailAddress(emailAddress) {
        var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
        return pattern.test(emailAddress);
    };

    function isValidCompanyName(companyName) {
        if (companyName.indexOf('@') > -1) {
            return false;
        } else {
            return true;
        }
    }

    // USER PROFILE INFORMATION
    // ===================================================================================================================
    $('body').on('click', '#update-user-profile', function() {
        $('.request-profile-fields .validate').each(function(index) {
            if (!$(this).val()) {
                $(this).addClass('error');
                return;
            }
        });

        var user_id = $('.client-info-wrapper').data('user-id');

        var first_name = sanitize($('.user-info-content-wrapper input[name="profile[name]"]').val());
        var company = sanitize($('.user-info-content-wrapper input[name="profile[company]"]').val());
        var comp_address = sanitize($('.user-info-content-wrapper input[name="profile[comp_address]"]').val());
        var last_name = sanitize($('.user-info-content-wrapper input[name="profile[surname]"]').val());
        var job = sanitize($('.user-info-content-wrapper input[name="profile[job]"]').val());
        var country = sanitize($('.user-info-content-wrapper input[name="profile[country]"]').val());
        var comp_code = sanitize($('.user-info-content-wrapper input[name="profile[comp_code]"]').val());
        var city = sanitize($('.user-info-content-wrapper input[name="profile[city]"]').val());
        var phone = sanitize($('.user-info-content-wrapper input[name="profile[phone]"]').val());
        var vat = sanitize($('.user-info-content-wrapper input[name="profile[vat]"]').val());
        var post = sanitize($('.user-info-content-wrapper input[name="profile[post]"]').val());


        var fd = new FormData();
        fd.append('action', 'update_user_meta_information');
        fd.append('first_name', first_name);
        fd.append('company', company);
        fd.append('comp_address', comp_address);
        fd.append('last_name', last_name);
        fd.append('job', job);
        fd.append('country', country);
        fd.append('comp_code', comp_code);
        fd.append('city', city);
        fd.append('phone', phone);
        fd.append('vat', vat);
        fd.append('post', post);

        $("#update-message").empty();
        $('#update-user-profile').css('display', 'none');
        $('.profile-update-loader-container').css('display', 'block');
        $.ajax({
            type: 'POST',
            url: ajax_object.ajaxurl,
            data: fd,
            contentType: false,
            processData: false,
            success: function(response) {
                console.log(response);
                $('#update-user-profile').css('display', 'inline-block');
                $('.profile-update-loader-container').css('display', 'none');
                $("#update-message").html('<p>Your profile information has been updated successfully!</p>');

            }
        });



    });


    $('body').on('click', '.paypal-button-container', function() {
        $(this).css('display', 'none');
        $("#paypal-button-container").css('display', 'block')
    });

    function sanitize(input) {
        var output = input;
        if (input != '' && input != undefined) {
            output = input.replace(/<script[^>]*?>.*?<\/script>/gi, '').
            replace(/<[\/\!]*?[^<>]*?>/gi, '').
            replace(/<style[^>]*?>.*?<\/style>/gi, '').
            replace(/<![\s\S]*?--[ \t\n\r]*>/gi, '');
        }
        return output;
    }

    function display_maintanance_form() {
        $('.maintanance-background').css('display', 'block');
        $('#maintanance-form').css('display', 'block');
    }

    function full_name_check(user_name) {
        if (user_name == undefined) {
            return true;
        }
        var name_arr = user_name.split(" ");
        var length = name_arr.length;
        if (length < 2) {
            return false;
        }

        return true;
    }
        // CLOSE FORM, AND UPDATE ALL SELECTIONS
    
        $('#front-page-one-search-nic-sic-forms').on('click','.popup-form .close-popup', closePopupWindow);
        $('#front-page-one-search-nic-sic-forms').on('click', '.popup-form .popup-done', closePopupWindow);

})(jQuery);

function empty(element) {
    while (element.firstElementChild) {
        element.firstElementChild.remove();
    }
}
